"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const LocalAgent_1 = __importDefault(require("./LocalAgent"));
const ws_1 = __importDefault(require("ws"));
const Info_1 = __importDefault(require("../util/Info"));
const AgentToken_1 = require("./AgentToken");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
if (!global.WebSocket) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    global.WebSocket = ws_1.default;
}
class AgentPlatformSDK {
    constructor() {
        if (!AgentPlatformSDK.instance) {
            AgentPlatformSDK.instance = this;
        }
        return AgentPlatformSDK.instance;
    }
    get version() {
        return Info_1.default.version;
    }
    get info() {
        return 'Version: ' + this.version + ' ' + Info_1.default.hash + ' ' + Info_1.default.date;
    }
    createAgent(agentToken) {
        return __awaiter(this, void 0, void 0, function* () {
            const token = new AgentToken_1.AgentToken(agentToken);
            const agent = yield LocalAgent_1.default.create(token);
            return agent;
        });
    }
}
exports.default = new AgentPlatformSDK();
